import {Component, inject} from '@angular/core';
import {NgbToast} from '@ng-bootstrap/ng-bootstrap';
import {ToastService} from "../../service/toast.service";

@Component({
  selector: 'green-x-toast',
  standalone: true,
  imports: [NgbToast],
  template: `
    <div class="app-toasts" aria-live="polite" aria-atomic="true">
      @for (toast of toastService.toasts(); track toast) {
        <ngb-toast
          [autohide]="true"
          [delay]="toast.delay ?? 3000"
          (hidden)="toastService.remove(toast)"
          [class]="toast.className"
        >
          @if (toast.html) {
            <span [innerHTML]="toast.body"></span>
          } @else {
            {{ toast.body }}
          }
        </ngb-toast>

      }
    </div>
  `,
  styles: [`
    .app-toasts {
      position: fixed;
      bottom: 1rem;
      left: 1rem;
      z-index: 1080;
      display: flex;
      flex-direction: column;
      gap: .5rem;
      pointer-events: none;
    }

    .app-toasts :where(ngb-toast) {
      pointer-events: auto;
    }

  `]
})
export class ToastComponent {
  toastService = inject(ToastService);
}
